import React, { Component, createContext } from "react";

const defaultState = {
  t: () => {},
  lang: "",
  siteCountry: "",
  pagePath: "/",
};

export const CustomI18nextContext = createContext(defaultState);

export class CustomI18nextProvider extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { t, lang, children } = this.props;
    const region = lang?.split("_")[0] || "";

    return (
      <CustomI18nextContext.Provider
        value={{
          t,
          lang,
          siteCountry: region === "en" ? "global" : region,
        }}
      >
        {children}
      </CustomI18nextContext.Provider>
    );
  }
}
